import { faker } from '@faker-js/faker'
import { MockFactory } from '@tino-frontend/mocks'
import { generateUUID } from '@fixtures/generate'
import { PaymentLinkInvoice } from '@types'

export function generatePaymentLinkInvoice(
  params?: Partial<PaymentLinkInvoice>
): PaymentLinkInvoice {
  return {
    ...params,
    id: params?.id ?? generateUUID(),
    created_at: params?.created_at ?? faker.date.recent().toISOString(),
    nfe_id: params?.nfe_id ?? generateUUID(),
    amount_cents:
      params?.amount_cents ?? faker.number.int({ min: 1000, max: 1000000 }),
    status:
      params?.status ??
      faker.helpers.arrayElement([
        'approved',
        'pending',
        'expired',
        'canceled',
        'error',
        'manual-audit',
      ]),
  }
}

export const paymentLinkInvoice = new MockFactory<PaymentLinkInvoice>({
  ...generatePaymentLinkInvoice({
    id: 'invoice_id',
    created_at: '2021-01-01T00:00:00.000Z',
    nfe_id: 'nfe_id',
    amount_cents: 1000,
    status: 'approved',
  }),
})
